'use client'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import React, { useCallback } from 'react'

import { Button, Text } from '@/components/ui'

import { PinCodeForm } from '@/modules/auth/pin-code-form'

import { SignInPopupProps } from '../SignInPopup.types'
import { appSelectors, useAppStore } from '@/store'
import { SignInForm } from '../../sign-in/SignInForm'
import { Else, If, Then } from 'react-if'
import { useLocalizedRoutes } from '@/lib/hooks'
import { ClientRoutes } from '@/config'
import { useRouter } from 'next/navigation'

export const SignIn: React.FC<SignInPopupProps> = ({
  setIsSignIn,
  onClose,
}) => {
  const t = useTranslations('auth.signInForm')
  const { verifyEmail } = useAppStore(appSelectors.auth)
  const { setSignupVisible } = useAppStore(appSelectors.actions)
  const { push } = useRouter()

  const { get: _ } = useLocalizedRoutes()

  const handleClosePopup = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <motion.div
      className={'SignInPopupOverlay__Form__SignIn'}
      transition={{
        duration: 0.2,
        ease: 'easeInOut',
      }}
      initial={{
        x: '100%',
      }}
      animate={{
        x: 0,
      }}
    >
      <If condition={verifyEmail}>
        <Then>
          <PinCodeForm />
        </Then>
        <Else>
          <>
            <SignInForm showOptions={false} onFinish={handleClosePopup} />

            <div className={'SignInPopupOverlay__Form__SignIn__divider'} />

            <div className="flex w-full flex-col items-center justify-center gap-2 mt-6">
              <Text variant="heading" className="text-white">
                {t('dontHaveAccount')}
              </Text>
              <Button
                type="button"
                onClick={() => setIsSignIn(false)}
                size="sm"
                variant="outline"
                className="w-auto p-6 mt-6 rounded-full border-white/60 text-white/70 text-lg"
              >
                {t('createAccount')}
              </Button>

              <Button
                onClick={() => {
                  push(_(ClientRoutes.forgotPassword))
                  setSignupVisible(false)
                }}
                size="sm"
                variant="outline"
                className="w-auto p-6 mt-3 rounded-full border-white/60 text-white/70 text-lg"
              >
                {t('forgotPassword')}
              </Button>
            </div>
          </>
        </Else>
      </If>
    </motion.div>
  )
}
